module.exports = __webpack_public_path__ + "static/media/3.7c341cb2.gif";